// test2420
(2420 && 0);
